const DEFAULT_TEAM_COLOR = '#7C3AED'

const normalizeTeamColor = (value) => {
  const normalizedColor = String(value ?? '')
    .trim()
    .toUpperCase()

  if (/^#[0-9A-F]{6}$/.test(normalizedColor)) {
    return normalizedColor
  }

  return DEFAULT_TEAM_COLOR
}

const toRgbChannels = (hexColor) => {
  const normalizedColor = normalizeTeamColor(hexColor)

  return [
    Number.parseInt(normalizedColor.slice(1, 3), 16),
    Number.parseInt(normalizedColor.slice(3, 5), 16),
    Number.parseInt(normalizedColor.slice(5, 7), 16),
  ]
}

export const setTeamThemeColor = (teamColor) => {
  if (typeof document === 'undefined') {
    return
  }

  const normalizedColor = normalizeTeamColor(teamColor)
  const [red, green, blue] = toRgbChannels(normalizedColor)
  const rootElement = document.documentElement

  rootElement.style.setProperty('--team-color', normalizedColor)
  rootElement.style.setProperty('--team-color-rgb', `${red}, ${green}, ${blue}`)
}
